import ApiService from "api/ApiService";

interface SelfResponse {
  username: string;
  email: string;
  has_privileged_access: boolean;
  message?: string;
}

export default class UserService {
  private static getUserUrl(): string {
    return "api";
  }

  public static async getSelf(): Promise<SelfResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getUserUrl()}/self`,
          method: "GET",
        },
        true,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
